import {Component, OnInit, DestroyRef} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import {DataService} from '../../../Services/data.service';
import {DatePipe} from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import {NavigationService} from '../../../Services/navigation.service';
import { StorageService } from '../../../Services/storage.service';
import { BsToastService } from '../../../Services/bs-toast-service';
import {ConfirmDialogService} from '../../../Services/confirm-dialog.service';
import {NgbDateStruct, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ResponseModel} from '../../../DataModels/response-model';

@Component({
  selector: 'app-employee-form',
  templateUrl: './employee-form.component.html',
  styleUrls: ['./employee-form.component.css'],
  standalone: false
})
export class EmployeeFormComponent implements OnInit {
  EmployeeForm: UntypedFormGroup;
  vm: any = {
    title: 'Employee Form',
    item: {},
    buttonsDisabled: false,
    isSendingOnboarding: false,
    gustoRequiredSteps: [] as any[],
    showOnboardingProgress: false,
    isCheckingOnboarding: false,
    Preferences: [],
    mainListPage: '/payroll/employee-list',
    formInitiated: false,
    defaultItem: [],
    departments: [],
    locations: [],
    approvers: [],
    employeeTypes: [],
    leaveBalances: [],
    leaveBalancesLoaded: false,
  };

  selectedLeaveYear: number = new Date().getFullYear();
  adjustLeaveType = 'pto';
  adjustHours: number = 0;
  adjustNote = '';
  adjustSubmitting = false;
  leaveTypeOptions = ['pto', 'sick', 'holiday'];

  // Leave balances datatable paging
  lbPage = 1;
  lbPageSize = 20;
  lbTotalRecords = 0;
  lbStartIndex = 0;
  lbEndIndex = 0;
  lbFilterText = '';
  lbPageSizeOptions = [10, 20, 50, 100];

  submitted = false;
  employeeId = '';
  isSaveNew = false;
  buttonConfig: any = {
    save: true,
    close: true,
    reset: true,
    delete: false,
    saveNew: true,
    saveClose: true,
    print: false,
  };
  //Every weekEmployees are paid weekly.52Every other weekEmployees are paid bi-weekly (every two weeks).26Twice per monthEmployees are paid semi-monthly on two fixed dates.24MonthlyEmployees are paid once a month.12
  payFrequencyOptions = ['Every Week', 'Every other week', 'Twice per month', 'Monthly'];
  flsaStatusOptions = ['Exempt', 'Non-exempt'];

  onboardingBadgeClass(status: string): string {
    switch (status) {
      case 'completed':
      case 'onboarding_completed':
        return 'bg-success';
      case 'in_progress':
        return 'bg-warning text-dark';
      case 'self_onboarding_invited':
        return 'bg-info text-dark';
      case 'not_started':
        return 'bg-danger';
      default:
        return 'bg-secondary';
    }
  }

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private localStorage: StorageService,
    private tableDataService: DataService,
    private notification: BsToastService,
    private datePipe: DatePipe,
    private titleService: Title,
    private formBuilder: UntypedFormBuilder,
    private nav: NavigationService,
    private confirmDialogService: ConfirmDialogService,
    private modalService: NgbModal,
    private destroyRef: DestroyRef,
  ) {}

  ngOnInit() {
    this.titleService.setTitle(this.vm.title);
    this.vm.Preferences = JSON.parse(this.localStorage.StorageGet('Preferences'));
    this.formInit();
    this.loadLookups();
    this.dataInit();
  }

  loadLookups() {
    this.tableDataService.getApiListData('pr_department', '?pageNumber=0&pageSize=999999').subscribe({
      next: (result: ResponseModel) => {
        this.vm.departments = result.Data;
      },
      error: (err) => console.error(err),
    });
    this.tableDataService.getApiListData('sys_user?state=active&pageNumber=0&pageSize=999999').subscribe({
      next: (result: ResponseModel) => {
        this.vm.approvers = result.Data;
        if (this.vm.item?.approver_id) {
          this.EmployeeForm.controls.item_approver_id.setValue(this.vm.item.approver_id);
        }
      },
      error: (err) => console.error(err),
    });
    this.tableDataService.getApiListData('location', '?pageNumber=0&pageSize=999999').subscribe({
      next: (result: ResponseModel) => {
        this.vm.locations = (result.Data as any[]).filter(l => l.gusto_location_uuid);
      },
      error: (err) => console.error(err),
    });
    this.tableDataService.getData('pr_employee_type').subscribe({
      next: (result: any) => {
        this.vm.employeeTypes = Array.isArray(result) ? result : (result.Data ?? []);
      },
      error: (err) => console.error(err),
    });
  }

  dataInit() {
    this.route.params.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((params) => {
      this.employeeId = params.id;
      if (this.employeeId !== undefined) {
        this.tableDataService.getData('employee', this.employeeId).subscribe({
          next: (result: any) => {
            this.vm.item = result;
            this.vm.formInitiated = true;
            this.vm.item.start_date = this.datePipe.transform(this.vm.item.start_date, 'MM/dd/yyyy');
            this.setValues();
            this.vm.defaultItem = result;
            this.buttonConfig.delete = true;
            this.loadLeaveBalances();
            if (result?.gusto_employee_id) {
              this.tableDataService.getData('Gusto/onboarding-status', result.id).subscribe({
                next: (status: any) => {
                  this.vm.item.gusto_onboarding_status = status?.onboarding_status ?? this.vm.item.gusto_onboarding_status;
                  this.vm.gustoRequiredSteps = status?.required_steps ?? [];
                },
                error: () => { /* silently ignore — badge will show stored status */
                },
              });
            }
          },
          error: (err) => {
            console.error(err);
            this.notification.showErrorToast($localize`:Error loading employee@@errorLoadingEmployee:Error loading employee`);
          },
        });
      }
    });
  }

  get f() {
    return this.EmployeeForm.controls;
  }

  formInit() {
    this.EmployeeForm = this.formBuilder.group({
      item_first_name: new UntypedFormControl('', Validators.required),
      item_last_name: new UntypedFormControl('', Validators.required),
      item_date_of_birth: new UntypedFormControl('', Validators.required),
      item_email: new UntypedFormControl('', [Validators.required, Validators.email]),
      item_department_id: new UntypedFormControl(''),
      item_start_date: new UntypedFormControl(new Date(), Validators.required),
      item_job_title: new UntypedFormControl(''),
      item_wage_amount: new UntypedFormControl(''),
      item_employee_pay_type: new UntypedFormControl('Hourly', Validators.required),
      item_is_exempt_from_time_tracking: new UntypedFormControl(false),
      item_pay_frequency: new UntypedFormControl('', Validators.required),
      item_flsa_status: new UntypedFormControl('', Validators.required),
      item_work_location_id: new UntypedFormControl(''),
      item_approver_id: new UntypedFormControl(''),
      item_address_1: new UntypedFormControl(''),
      item_address_2: new UntypedFormControl(''),
      item_city: new UntypedFormControl(''),
      item_state_province: new UntypedFormControl(''),
      item_postal_code: new UntypedFormControl(''),
      item_phone: new UntypedFormControl(''),
      item_active: new UntypedFormControl(true),
      item_employee_type_id: new UntypedFormControl(''),
      item_project_timekeeping_enabled: new UntypedFormControl(false),
      item_project_user_id: new UntypedFormControl(''),
      item_default_bill_rate: new UntypedFormControl(null),
      item_default_cost_rate: new UntypedFormControl(null),
    });
  }

  setValues() {
    this.EmployeeForm.controls.item_first_name.setValue(this.vm.item.first_name);
    this.EmployeeForm.controls.item_last_name.setValue(this.vm.item.last_name);
    this.EmployeeForm.controls.item_date_of_birth.setValue(this.isoToNgbDate(this.vm.item.date_of_birth));
    this.EmployeeForm.controls.item_email.setValue(this.vm.item.email);
    this.EmployeeForm.controls.item_department_id.setValue(this.vm.item.department_id);
    this.EmployeeForm.controls.item_start_date.setValue(this.vm.item.start_date);
    this.EmployeeForm.controls.item_job_title.setValue(this.vm.item.job_title);
    this.EmployeeForm.controls.item_wage_amount.setValue(this.vm.item.wage_amount);
    this.EmployeeForm.controls.item_employee_pay_type.setValue(this.vm.item.employee_pay_type ?? 'Hourly');
    this.EmployeeForm.controls.item_is_exempt_from_time_tracking.setValue(this.vm.item.is_exempt_from_time_tracking ?? false);
    this.EmployeeForm.controls.item_pay_frequency.setValue(this.vm.item.pay_frequency);
    this.EmployeeForm.controls.item_flsa_status.setValue(this.vm.item.flsa_status);
    this.EmployeeForm.controls.item_work_location_id.setValue(this.vm.item.work_location_id);
    this.EmployeeForm.controls.item_approver_id.setValue(this.vm.item.approver_id);
    this.EmployeeForm.controls.item_address_1.setValue(this.vm.item.address_1);
    this.EmployeeForm.controls.item_address_2.setValue(this.vm.item.address_2);
    this.EmployeeForm.controls.item_city.setValue(this.vm.item.city);
    this.EmployeeForm.controls.item_state_province.setValue(this.vm.item.state_province);
    this.EmployeeForm.controls.item_postal_code.setValue(this.vm.item.postal_code);
    this.EmployeeForm.controls.item_phone.setValue(this.vm.item.phone);
    this.EmployeeForm.controls.item_active.setValue(this.vm.item.active);
    this.EmployeeForm.controls.item_employee_type_id.setValue(this.vm.item.employee_type_id);
    this.EmployeeForm.controls.item_project_timekeeping_enabled.setValue(this.vm.item.project_timekeeping_enabled ?? false);
    this.EmployeeForm.controls.item_project_user_id.setValue(this.vm.item.project_user_id ?? '');
    this.EmployeeForm.controls.item_default_bill_rate.setValue(this.vm.item.default_bill_rate ?? null);
    this.EmployeeForm.controls.item_default_cost_rate.setValue(this.vm.item.default_cost_rate ?? null);
  }

  setupValuesForSave() {
    this.vm.item.first_name = this.EmployeeForm.controls.item_first_name.value;
    this.vm.item.last_name = this.EmployeeForm.controls.item_last_name.value;
    this.vm.item.date_of_birth = this.ngbDateToIso(this.EmployeeForm.controls.item_date_of_birth.value);
    this.vm.item.email = this.EmployeeForm.controls.item_email.value;
    this.vm.item.department_id = this.EmployeeForm.controls.item_department_id.value || null;
    this.vm.item.start_date = new Date(this.EmployeeForm.controls.item_start_date.value).toISOString();
    this.vm.item.job_title = this.EmployeeForm.controls.item_job_title.value;
    this.vm.item.wage_amount = this.EmployeeForm.controls.item_wage_amount.value;
    this.vm.item.employee_pay_type = this.EmployeeForm.controls.item_employee_pay_type.value;
    this.vm.item.is_exempt_from_time_tracking = this.EmployeeForm.controls.item_is_exempt_from_time_tracking.value === true || this.EmployeeForm.controls.item_is_exempt_from_time_tracking.value === 'true';
    this.vm.item.pay_frequency = this.EmployeeForm.controls.item_pay_frequency.value;
    this.vm.item.flsa_status = this.EmployeeForm.controls.item_flsa_status.value;
    this.vm.item.work_location_id = this.EmployeeForm.controls.item_work_location_id.value || null;
    this.vm.item.approver_id = this.EmployeeForm.controls.item_approver_id.value || null;
    this.vm.item.address_1 = this.EmployeeForm.controls.item_address_1.value;
    this.vm.item.address_2 = this.EmployeeForm.controls.item_address_2.value;
    this.vm.item.city = this.EmployeeForm.controls.item_city.value;
    this.vm.item.state_province = this.EmployeeForm.controls.item_state_province.value;
    this.vm.item.postal_code = this.EmployeeForm.controls.item_postal_code.value;
    this.vm.item.phone = this.EmployeeForm.controls.item_phone.value;
    this.vm.item.active = this.EmployeeForm.controls.item_active.value;
    this.vm.item.employee_type_id = this.EmployeeForm.controls.item_employee_type_id.value || null;
    this.vm.item.project_timekeeping_enabled = this.EmployeeForm.controls.item_project_timekeeping_enabled.value === true || this.EmployeeForm.controls.item_project_timekeeping_enabled.value === 'true';
    this.vm.item.project_user_id = this.EmployeeForm.controls.item_project_user_id.value || null;
    this.vm.item.default_bill_rate = this.EmployeeForm.controls.item_default_bill_rate.value !== '' ? this.EmployeeForm.controls.item_default_bill_rate.value : null;
    this.vm.item.default_cost_rate = this.EmployeeForm.controls.item_default_cost_rate.value !== '' ? this.EmployeeForm.controls.item_default_cost_rate.value : null;
  }

  saveClose() {
    this.onSave(true);
  }

  saveNew() {
    this.isSaveNew = true;
    this.onSave(false);
  }

  resetForm() {
    this.resetToDefaults();
  }

  onClose() {
    this.nav.backOr(this.vm.mainListPage);
  }

  deleteItem() {
    if (!this.vm.item.id) {
      return;
    }
    const messages: string[] = [$localize`:Delete this record? @@deletethisrecord:Delete this record?`, ''];
    this.confirmDialogService.confirmThis(
      messages,
      () => {
        this.tableDataService.deleteDataById('employee', this.vm.item.id).subscribe({
          next: () => {
            this.notification.showSuccessToast($localize`:Deleted@@deleted:Deleted`);
            this.onClose();
          },
          error: (err) => {
            console.error(err);
            this.notification.showErrorToast($localize`:Error deleting record@@errorDeletingRecord:Error deleting record`);
          },
        });
      },
      () => {
        this.notification.showSuccessToast($localize`:Delete Canceled @@deleteCanceled:Delete Canceled`);
      }
    );
  }

  loadLeaveBalances() {
    if (!this.employeeId) {
      return;
    }
    this.vm.leaveBalancesLoaded = false;
    const params = `?employee_id=${this.employeeId}&effective_year=${this.selectedLeaveYear}&pageNumber=${this.lbPage - 1}&pageSize=${this.lbPageSize}`;
    this.tableDataService.getApiListData('pr_leave_balance', params).subscribe({
      next: (result: any) => {
        this.vm.leaveBalances = Array.isArray(result) ? result : (result.Data ?? []);
        this.lbTotalRecords = result?.TotalRecords ?? this.vm.leaveBalances.length;
        this.lbStartIndex = this.lbTotalRecords === 0 ? 0 : (this.lbPage - 1) * this.lbPageSize + 1;
        this.lbEndIndex = Math.min(this.lbPage * this.lbPageSize, this.lbTotalRecords);
        this.vm.leaveBalancesLoaded = true;
      },
      error: (err) => console.error(err),
    });
  }

  onLbPageChange(page: number) {
    this.lbPage = page;
    this.loadLeaveBalances();
  }

  onLbPageSizeChange(size: number) {
    this.lbPageSize = size;
    this.lbPage = 1;
    this.loadLeaveBalances();
  }

  onLeaveYearChange() {
    this.loadLeaveBalances();
  }

  openAdjustModal(content: any) {
    this.adjustLeaveType = 'pto';
    this.adjustHours = 0;
    this.adjustNote = '';
    this.modalService.open(content, {ariaLabelledBy: 'adjustModalLabel'});
  }

  submitAdjustment(modal: any) {
    if (this.adjustSubmitting) {
      return;
    }
    this.adjustSubmitting = true;
    const payload = {
      employee_id: this.vm.item.id,
      leave_type: this.adjustLeaveType,
      hours: this.adjustHours,
      note: this.adjustNote,
    };
    this.tableDataService.post('pr_leave_balance/adjust', payload).subscribe({
      next: () => {
        this.notification.showSuccessToast($localize`:Balance adjusted@@balanceAdjusted:Balance adjusted`);
        this.adjustSubmitting = false;
        modal.close();
        this.loadLeaveBalances();
      },
      error: (err) => {
        console.error(err);
        this.adjustSubmitting = false;
        this.notification.showErrorToast($localize`:Error adjusting balance@@errorAdjustingBalance:Error adjusting balance`);
      },
    });
  }

  pushToGusto() {
    if (!this.vm.item.id || this.vm.buttonsDisabled) {
      return;
    }
    this.vm.buttonsDisabled = true;
    this.tableDataService.post('Gusto/push-employee/' + this.vm.item.id, {}).subscribe({
      next: () => {
        this.notification.showSuccessToast($localize`:Pushed to Gusto@@pushedToGusto:Pushed to Gusto`);
        this.reloadEmployee();
      },
      error: (err) => {
        this.vm.buttonsDisabled = false;
        console.error(err);
        this.notification.showErrorToast($localize`:Error pushing to Gusto@@errorPushingToGusto:Error pushing to Gusto`);
      },
    });
  }

  sendOnboardingEmail() {
    if (!this.vm.item?.id || this.vm.isSendingOnboarding) {
      return;
    }
    this.vm.isSendingOnboarding = true;
    this.tableDataService.post('Gusto/invite-to-onboard/' + this.vm.item.id, {}).subscribe({
      next: (res: any) => {
        this.vm.isSendingOnboarding = false;
        this.notification.showSuccessToast(res?.message ?? $localize`:OnboardingEmailSent@@onboardingEmailSent:Onboarding email sent`);
      },
      error: (err: any) => {
        this.vm.isSendingOnboarding = false;
        this.notification.showErrorToast(err?.error?.message ?? $localize`:OnboardingEmailError@@onboardingEmailError:Error sending onboarding email`);
      },
    });
  }

  onboardingStepIds(steps: any[]): string {
    return steps?.map(s => s.id).join(', ') ?? '';
  }

  syncWithGusto() {
    const id = this.vm.item?.id ?? this.employeeId;
    if (!id || this.vm.buttonsDisabled) {
      return;
    }
    this.vm.buttonsDisabled = true;
    this.tableDataService.post(`Gusto/sync-employee/${id}`, {}).subscribe({
      next: (res: any) => {
        this.notification.showSuccessToast(res?.message ?? $localize`:SyncSuccess@@syncSuccess:Employee synced from Gusto.`);
        this.reloadEmployee();
      },
      error: (err: any) => {
        this.vm.buttonsDisabled = false;
        this.notification.showErrorToast(err?.error?.message ?? $localize`:SyncError@@syncError:Error syncing employee from Gusto.`);
      },
    });
  }

  checkOnboardingProgress() {
    const id = this.vm.item?.id ?? this.employeeId;
    if (!id || this.vm.isCheckingOnboarding) {
      return;
    }
    this.vm.isCheckingOnboarding = true;
    this.vm.showOnboardingProgress = true;
    this.tableDataService.getData('Gusto/onboarding-status', id).subscribe({
      next: (status: any) => {
        this.vm.isCheckingOnboarding = false;
        this.vm.item.gusto_onboarding_status = status?.onboarding_status ?? this.vm.item.gusto_onboarding_status;
        this.vm.gustoRequiredSteps = (status?.onboarding_steps ?? []).filter((s: any) => s.required);
      },
      error: (err: any) => {
        this.vm.isCheckingOnboarding = false;
        this.notification.showErrorToast(err?.error?.message ?? $localize`:ErrorCheckingOnboarding@@errorCheckingOnboarding:Error checking onboarding status`);
      },
    });
  }

  reloadEmployee() {
    this.tableDataService.getData('employee', this.employeeId).subscribe({
      next: (result: any) => {
        this.vm.item = result;
        this.vm.item.start_date = this.datePipe.transform(this.vm.item.start_date, 'MM/dd/yyyy');
        this.setValues();
        this.vm.buttonsDisabled = false;
        if (result?.gusto_employee_id) {
          this.tableDataService.getData('Gusto/onboarding-status', result.id).subscribe({
            next: (status: any) => {
              this.vm.item.gusto_onboarding_status = status?.onboarding_status ?? this.vm.item.gusto_onboarding_status;
              this.vm.gustoRequiredSteps = status?.required_steps ?? [];
            },
            error: () => { /* silently ignore */
            },
          });
        }
      },
      error: (err) => {
        console.error(err);
        this.vm.buttonsDisabled = false;
      },
    });
  }

  private isoToNgbDate(iso: string | null | undefined): NgbDateStruct | null {
    if (!iso) {
      return null;
    }
    const d = new Date(iso);
    if (isNaN(d.getTime())) {
      return null;
    }
    return {year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate()};
  }

  private ngbDateToIso(d: NgbDateStruct | string | null | undefined): string | null {
    if (!d) {
      return null;
    }
    if (typeof d === 'string') {
      return d.length >= 10 ? d.substring(0, 10) : null;
    }
    if (typeof d !== 'object' || d.year == null || d.month == null || d.day == null) {
      return null;
    }
    const m = String(d.month).padStart(2, '0');
    const day = String(d.day).padStart(2, '0');
    return `${d.year}-${m}-${day}`;
  }

  private resetToDefaults(): void {
    this.EmployeeForm.reset({
      item_first_name: '',
      item_last_name: '',
      item_date_of_birth: null,
      item_email: '',
      item_department_id: '',
      item_start_date: new Date(),
      item_job_title: '',
      item_wage_amount: '',
      item_employee_pay_type: 'Hourly',
      item_is_exempt_from_time_tracking: false,
      item_pay_frequency: '',
      item_flsa_status: '',
      item_work_location_id: '',
      item_address_1: '',
      item_address_2: '',
      item_city: '',
      item_state_province: '',
      item_postal_code: '',
      item_phone: '',
      item_active: true,
      item_employee_type_id: '',
    });
    this.vm.item = {};
    this.vm.leaveBalances = [];
    this.vm.leaveBalancesLoaded = false;
    this.submitted = false;
    this.vm.buttonsDisabled = false;
    this.employeeId = '';
  }

  onSave(saveClose: boolean) {
    if (this.vm.buttonsDisabled) {
      return false;
    }
    this.submitted = true;
    this.vm.buttonsDisabled = true;

    if (this.EmployeeForm.invalid) {
      const fieldLabels: { [key: string]: string } = {
        item_first_name: 'First Name',
        item_last_name: 'Last Name',
        item_date_of_birth: 'Date of Birth',
        item_email: 'Email',
        item_start_date: 'Start Date',
        item_employee_pay_type: 'Pay Type',
        item_pay_frequency: 'Pay Frequency',
        item_flsa_status: 'FLSA Status',
      };
      const invalidFields = Object.keys(this.EmployeeForm.controls)
        .filter(k => this.EmployeeForm.controls[k].invalid)
        .map(k => fieldLabels[k] ?? k)
        .join(', ');
      this.notification.showWarningToast(`Form Errors! Invalid fields: ${invalidFields}`);
      this.vm.buttonsDisabled = false;
      return false;
    }

    this.setupValuesForSave();
    const {audit_sequence, ...payload} = this.vm.item;

    if (this.vm.item.id === undefined) {
      this.tableDataService.post('employee', payload).subscribe({
        next: () => {
          this.notification.showSuccessToast($localize`:Saved@@saved:Saved`);
          this.vm.buttonsDisabled = false;
          this.submitted = false;
          if (saveClose) {
            this.onClose();
          } else if (this.isSaveNew) {
            this.resetToDefaults();
            this.isSaveNew = false;
          }
        },
        error: (error: any) => {
          this.vm.buttonsDisabled = false;
          console.error(error);
        },
        complete: () => {
          this.vm.buttonsDisabled = false;
          this.submitted = false;
        },
      });
    } else {
      this.tableDataService
        .patch('employee', this.vm.item.id, payload)
        .then(() => {
          this.notification.showSuccessToast($localize`:Saved@@saved:Saved`);
          if (saveClose) {
            this.onClose();
          } else if (this.isSaveNew) {
            this.resetToDefaults();
            this.isSaveNew = false;
          }
        })
        .catch((error: any) => {
          this.vm.buttonsDisabled = false;
          console.error(error);
        })
        .finally(() => {
          this.vm.buttonsDisabled = false;
          this.submitted = false;
        });
    }
    return true;
  }
}
